module.exports = __webpack_public_path__ + "img/Churned customers Icon - white.acc76f85.svg";